/** A stable hue (0-359) from any string, so one person always has one color. */
export function hueOf(key: string): number {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) % 360;
  return hash;
}

/** First visible character of a name (an emoji or accented letter stays whole). */
export function initialOf(name: string): string {
  const first = new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    .segment(name.trim())
    [Symbol.iterator]()
    .next();
  const letter = first.done ? undefined : first.value.segment;
  return letter ? letter.toLocaleUpperCase() : '?';
}
